export default __webpack_public_path__ + "static/media/810.76e2c768.gif";